var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filmModel && _vm.filmModel.content
    ? _c(
        "section",
        { staticClass: "page film" },
        [
          _vm.filmModel.use_image
            ? _c("img", {
                staticClass: "film-image",
                attrs: {
                  src: _vm.filmModel.image_link,
                  alt: _vm.filmModel.title + " - screenshot"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.filmModel.use_image && !_vm.filmModel.youtube_link
            ? _c("vimeo-player", {
                attrs: {
                  "video-id": _vm.filmModel.vimeo_link,
                  "player-width": "640",
                  "player-height": "360"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.filmModel.youtube_link && !_vm.filmModel.use_image
            ? _c("div", { attrs: { id: "youtube-player" } }, [
                !_vm.filmModel.use_image && _vm.filmModel.youtube_link
                  ? _c("iframe", {
                      staticStyle: {
                        border: "0px #ffffff none",
                        width: "100%",
                        "aspect-ratio": "16/9"
                      },
                      attrs: {
                        src: _vm.youtubeLink,
                        name: "youtube-player",
                        scrolling: "no",
                        frameborder: "1",
                        marginheight: "0px",
                        marginwidth: "0px",
                        height: "360px",
                        width: "640px",
                        allowfullscreen: ""
                      }
                    })
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("header", { staticClass: "film-header" }, [
            _c("p", { staticClass: "text-uppercase" }, [
              _c("span", { staticClass: "no" }, [
                _vm._v(_vm._s(_vm.paddedNumber))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.filmModel.title))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "year" }, [
                _vm._v(_vm._s(_vm.filmModel.year))
              ])
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("p", { staticClass: "excerpt" }, [
              _vm._v(_vm._s(_vm.filmModel.excerpt))
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "film-content",
            class: { hidden: !_vm.contentVisible },
            domProps: { innerHTML: _vm._s(_vm.filmModel.content) }
          })
        ],
        1
      )
    : _c("section")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }